import React from "react";

export const postalColumns = [
  {
    title: () => (
      <span className="font-bold text-sgbc-green-300">
        Postal Sector <br /> (1st 2 digits of 6 - digit postal codes)
      </span>
    ),
    dataIndex: "postal_sector",
    key: "apostal_sectorge",
  },
  {
    title: () => (
      <span className="font-bold text-sgbc-green-300">Neighbourhood Towns</span>
    ),
    dataIndex: "neighbourhood_towns",
    key: "neighbourhood_towns",
  },
];

export const postalList = [
  {
    key: "01",
    postal_district: "01",
    postal_sector: "01, 02, 03, 04, 05, 06",
    neighbourhood_towns: "Raffles Place, Cecil, Marina, People's Park",
  },
  {
    key: "02",
    postal_district: "02",
    postal_sector: "07, 08",
    neighbourhood_towns: "Anson, Tanjong Pagar",
  },
  {
    key: "03",
    postal_district: "03",
    postal_sector: "14,15, 16",
    neighbourhood_towns: "Queenstown, Tiong Bahru",
  },
  {
    key: "04",
    postal_district: "04",
    postal_sector: "09, 10",
    neighbourhood_towns: "Telok Blangah, Harbourfront",
  },
  {
    key: "05",
    postal_district: "05",
    postal_sector: "11, 12, 13",
    neighbourhood_towns: "Pasir Panjang, Hong Leong Garden, Clementi New Town",
  },
  {
    key: "06",
    postal_district: "06",
    postal_sector: "17",
    neighbourhood_towns: "High Street, Beach Road (part)",
  },
  {
    key: "07",
    postal_district: "07",
    postal_sector: "18, 19",
    neighbourhood_towns: "Middle Road, Golden Mile",
  },
  {
    key: "08",
    postal_district: "08",
    postal_sector: "20, 21",
    neighbourhood_towns: "Little India",
  },
  {
    key: "09",
    postal_district: "09",
    postal_sector: "22, 23",
    neighbourhood_towns: "Orchard, Cairnhill, River Valley",
  },
  {
    key: "10",
    postal_district: "10",
    postal_sector: "24, 25, 26, 27",
    neighbourhood_towns: "Ardmore, Bukit Timah, Holland Road, Tanglin",
  },
  {
    key: "11",
    postal_district: "11",
    postal_sector: "28, 29, 30",
    neighbourhood_towns: "Watten Estate, Novena, Thomson",
  },
  {
    key: "12",
    postal_district: "12",
    postal_sector: "31, 32, 33",
    neighbourhood_towns: "Balestier, Toa Payoh, Serangoon",
  },
  {
    key: "13",
    postal_district: "13",
    postal_sector: "34, 35, 36, 37",
    neighbourhood_towns: "Macpherson, Braddell",
  },
  {
    key: "14",
    postal_district: "14",
    postal_sector: "38, 39, 40, 41",
    neighbourhood_towns: "Geylang, Eunos",
  },
  {
    key: "15",
    postal_district: "15",
    postal_sector: "42, 43, 44, 45",
    neighbourhood_towns: "Katong, Joo Chiat, Amber Road",
  },
  {
    key: "16",
    postal_district: "16",
    postal_sector: "46, 47, 48",
    neighbourhood_towns: "Bedok, Upper East Coast, Eastwood, Kew Drive",
  },
  {
    key: "17",
    postal_district: "17",
    postal_sector: "49, 50, 81",
    neighbourhood_towns: "Loyang, Changi",
  },
  {
    key: "18",
    postal_district: "18",
    postal_sector: "51, 52",
    neighbourhood_towns: "Tampines, Pasir Ris",
  },
  {
    key: "19",
    postal_district: "19",
    postal_sector: "53, 54, 55, 82",
    neighbourhood_towns: "Serangoon Garden, Hougang, Punggol",
  },
  {
    key: "20",
    postal_district: "20",
    postal_sector: "56, 57",
    neighbourhood_towns: "Bishan, Ang Mo Kio",
  },
  {
    key: "21",
    postal_district: "21",
    postal_sector: "58, 59",
    neighbourhood_towns: "Upper Bukit Timah, Clementi Park, Ulu Pandan",
  },
  {
    key: "22",
    postal_district: "22",
    postal_sector: "60, 61, 62, 63, 64",
    neighbourhood_towns: "Jurong",
  },
  {
    key: "23",
    postal_district: "23",
    postal_sector: "65, 66, 67, 68",
    neighbourhood_towns: "Hillview, Dairy Farm, Bukit Panjang, Choa Chu Kang",
  },
  {
    key: "24",
    postal_district: "24",
    postal_sector: "69, 70, 71",
    neighbourhood_towns: "Lim Chu Kang, Tengah",
  },
  {
    key: "25",
    postal_district: "25",
    postal_sector: "72, 73",
    neighbourhood_towns: "Kranji, Woodgrove",
  },
  {
    key: "26",
    postal_district: "26",
    postal_sector: "77, 78",
    neighbourhood_towns: "Upper Thomson, Springleaf",
  },
  {
    key: "27",
    postal_district: "27",
    postal_sector: "75, 76",
    neighbourhood_towns: "Yishun, Sembawang",
  },
  {
    key: "28",
    postal_district: "28",
    postal_sector: "79, 80",
    neighbourhood_towns: "Seletar",
  },
];
